module.exports = __webpack_public_path__ + "494cd07c/img/google.68f3823e.svg";